// Cálculo de preços de planos (titular, dependentes e pets).
// Usado tanto pelo wizard de contratação (PlansWizard) quanto pela barra de resumo (PriceSummaryBar)
// para evitar que as duas telas divirjam no valor calculado para o mesmo caso.

import { getAgeFromBirthDate } from './validators';

export const PET_PLAN_FALLBACK_PRICES = {
  '4932': { valor: 10.0, desc: 'Cremação Coletiva Pet' },
  '4934': { valor: 15.0, desc: 'Sepultamento Pet' },
  '4936': { valor: 15.0, desc: 'Cremação Individual Pet' },
};

export const calculateAge = (birthDate) => getAgeFromBirthDate(birthDate);

export const getTitularPriceByAge = (age, plan) => {
  if (age == null || !plan) return 0;

  if (plan.pricingTiers && Array.isArray(plan.pricingTiers) && plan.pricingTiers.length > 0) {
    const faixa = plan.pricingTiers.find((t) => {
      const de = typeof t.idadeDe === 'number' ? t.idadeDe : -Infinity;
      const ate = typeof t.idadeAte === 'number' ? t.idadeAte : Infinity;
      return age >= de && age <= ate;
    });
    return faixa ? faixa.valorReais : 0;
  }

  if (plan.pricing) {
    const planPricing = plan.pricing;
    if (age <= 18 && planPricing['0-18'] != null) return planPricing['0-18'];
    if (age <= 49 && planPricing['19-49'] != null) return planPricing['19-49'];
    if (age <= 59 && planPricing['50-59'] != null) return planPricing['50-59'];
    if (age <= 69 && planPricing['60-69'] != null) return planPricing['60-69'];
    if (age <= 79 && planPricing['70-79'] != null) return planPricing['70-79'];
    if (age <= 89 && planPricing['80-89'] != null) return planPricing['80-89'];
    if (planPricing['90+'] != null) return planPricing['90+'];
  }

  return 0;
};

// Retorna null (em vez de 0) quando o valor não foi encontrado na API, para
// diferenciar "dependente grátis" de "ainda não sabemos o preço".
export const getDependentPriceByAge = (age, pricing, selectedPlan) => {
  if (age == null) return null;

  if (pricing && pricing.dependentes && selectedPlan) {
    const idPlano = String(selectedPlan.idPlano);
    const dependentesData = pricing.dependentes[idPlano];

    if (dependentesData && dependentesData.tiers && Array.isArray(dependentesData.tiers)) {
      const faixa = dependentesData.tiers.find((t) => {
        const de = typeof t.idadeDe === 'number' ? t.idadeDe : -Infinity;
        const ate = typeof t.idadeAte === 'number' ? t.idadeAte : Infinity;
        return age >= de && age <= ate;
      });

      if (faixa && faixa.valorReais != null) {
        return faixa.valorReais;
      }
    }
  }

  return null;
};

export const extractPetPlanId = (service) => {
  if (!service) return null;
  const match = service.match(/pet-plan-(\d+)/);
  return match ? match[1] : null;
};

// Preço e descrição do serviço PET de um dependente-pet (plano normal, pet com serviço avulso).
export const getPetPrice = (pet, pricing, selectedPlan) => {
  const petPlanId = extractPetPlanId(pet.service);
  if (!petPlanId) return { price: 0, desc: 'Assistência Pet' };

  if (pricing && pricing.dependentes && selectedPlan && selectedPlan.idPlano) {
    const idPlano = String(selectedPlan.idPlano);
    const dependentesData = pricing.dependentes[idPlano];
    const petPlan = dependentesData?.pets?.[petPlanId];
    if (petPlan && petPlan.valor !== undefined) {
      return { price: petPlan.valor, desc: petPlan.desc || PET_PLAN_FALLBACK_PRICES[petPlanId]?.desc || 'Assistência Pet' };
    }
  }

  const fallback = PET_PLAN_FALLBACK_PRICES[petPlanId];
  return fallback ? { price: fallback.valor, desc: fallback.desc } : { price: 0, desc: 'Assistência Pet' };
};

// Preço do plano PET exclusivo em si (quando somentePET === true).
export const getExclusivePetPlanPrice = (pricing, selectedPlan) => {
  const idPlano = String(selectedPlan.idPlano);
  if (pricing && pricing.planos && pricing.planos[idPlano]) {
    return pricing.planos[idPlano].minValue || 0;
  }
  const fallback = PET_PLAN_FALLBACK_PRICES[idPlano];
  return fallback ? fallback.valor : 0;
};
